import BaseApi from './baseApi';
import IListCountries from '../models/IListCountries';
import IAuthentication from '../models/IAuthentication';
export default class ListCountriesApi extends BaseApi {
    idUser : string = "";
    idCompany : string = "";
    constructor() {
        super("dataaccess", "Settings");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.idCompany = userFromStorage.idCompany;
    }

    async GetListCountries() : Promise<IListCountries[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var listCountries: IListCountries[] = [];
            listCountries = response.data as IListCountries[];
            return listCountries;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveListCountries(listCountry: IListCountries) : Promise<string> {
        const json = this.getJsonSave(listCountry);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateListCountries(listCountry: IListCountries) : Promise<boolean> {
        const json = this.getJsonUpdate(listCountry);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteListCountries(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async inUseSetting(id: string) : Promise<boolean> {
        const json = this.getInUseJson(id);
        const response = await this.api.post('ExecWithResults', json);
        if (!response) return false;
        if (response.isSuccess) {
            const data = response.data as any[];
            return Number(data && data[0] && data[0].isInUse) === 1;
        } else {
            this.modelState = response.errorState;
            return false;
        }
    }

    private getInUseJson(id: string) : any {
        const json = {
            "spname": "dbo.IS_COUNTRY_IN_USE",
            "parameters": [{
                "Item1": "CountryId ",
                "Item2": id
            }, {
                "Item1": "companyId ",
                "Item2": this.idCompany
            }]
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "ListCountries",
                "Item2": "id"
            }, {
                "Item1": "ListCountries",
                "Item2": "countryName"
            }, {
                "Item1": "ListCountries",
                "Item2": "Code"
            }],
            "tables": [{
                "Item1": "ListCountries"
            }],
            "conditions": [{
                "Item1": "ListCountries",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "ListCountries",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": this.idCompany
            }],
            "orderBy": [{
                "Item1": "ListCountries.countryName"
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "ListCountries",
            "conditions": [{
                "Item1": "ListCountries",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(listCountry: IListCountries) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "countryName",
                "Item2": listCountry.countryName
            }, {
                "Item1": "code",
                "Item2": listCountry.code
            }, {
                "Item1": "idCompany",
                "Item2": this.idCompany
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "ListCountries"
        };
        return json;
    }

    private getJsonUpdate(listCountry: IListCountries) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "countryName",
                "Item2": listCountry.countryName
            }, {
                "Item1": "code",
                "Item2": listCountry.code
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "ListCountries",
            "keyvalue": listCountry.id
        };
        return json;
    }
}
